import React from 'react';
import loadable from '@loadable/component';
import APIS from '../../constant/Endpoint';
import usePostHook from '../../customHooks/usePostHook';
import useGetHook from '../../customHooks/useGetHook';
import { useNavigate } from 'react-router-dom';

const CreateEmailCampaignComponent = loadable(
  () =>
    import(
      '../../components/EmailCampaign/EmailCampaignCreate/EmailCampaignCreate'
    )
);
const CreateEmailCampaign = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['email-campaign'],
  });

  const { refetch } = useGetHook({
    queryKey: ['emails'],
    url: APIS.SENDER_EMAIL,
    params: {
      is_default: true,
    },
  });

  const handleCreate = async (values: any, setError: any, isDraft: boolean) => {
    const url = APIS.EMAIL_CAMPAIGN;
    const formData = {
      ...values,
      is_draft: isDraft,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        navigate('/email-sms-marketing/email-campaign');
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <CreateEmailCampaignComponent
      handleCreate={handleCreate}
      isPostLoading={isPostLoading}
      refetch={refetch}
    />
  );
};

export default CreateEmailCampaign;
